import React from 'react';
import { ChevronRightIcon, FilterIcon, LinkIcon, PlaySquareIcon } from 'lucide-react';
import { Card, CardLabel, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
const steps = [{
  number: '1',
  icon: PlaySquareIcon,
  title: 'Interactive video snaks',
  body: 'Sit inside the pages, CRM journeys and Wordpress templates you already run.',
  accent: 'var(--brand-green-lighter)'
}, {
  number: '2',
  icon: FilterIcon,
  title: 'Qualify HCP interest',
  body: 'A dynamic content navigation format, not an algorithmic survey tool.',
  accent: 'var(--brand-green-light)'
}, {
  number: '3',
  icon: LinkIcon,
  title: 'Hand off to your tools',
  body: 'The CTA sends engaged HCPs into surveys, diagnostics, guides and CRM capture.',
  accent: 'var(--brand-green)'
}];
export function TechStackSlide() {
  return <Slide data-id="element-224" data-mp="1z0exqbt841jx">
      <SlideHeader eyebrow="Playing nicely with your tech stack" data-id="element-225" data-mp="1tzh678mbpv5r">
        We work with tools like Alchema, your CRM and Wordpress, and{' '}
        <Hi data-id="element-226" data-mp="2aki2etymegyx">maximize the impact they already bring.</Hi>
      </SlideHeader>

      <div className="flex min-h-0 flex-1 items-stretch gap-[clamp(0.75rem,1.5vw,1.5rem)]" data-id="element-227" data-mp="2fi0g0xnl1kd9">
        {steps.map((step, index) => <React.Fragment key={step.number} data-id="element-228" data-mp="2jjby8i44n3bf" data-mpi={index}>
            <Fade delay={0.2 + index * 0.12} className="flex flex-1" data-id="element-229" data-mp="2oatxn1qi4vua">
              <Card className="relative flex flex-1 flex-col overflow-hidden" data-id="element-230" data-mp="2oc5110g1c1kv">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full" style={{
              backgroundColor: step.accent
            }} data-id="element-231" data-mp="2t959fi0cxgf5">
                  <step.icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-232" data-mp="3395qsyeo1mgp" />
                </div>
                <CardLabel data-id="element-233" data-mp="378enab13byfy">Step {step.number}</CardLabel>
                <h3 className="mt-1 text-[clamp(1.05rem,1.6vw,1.6rem)] font-bold leading-tight text-[var(--fg)]" data-id="element-234" data-mp="18ucz3agwlfu1">
                  {step.title}
                </h3>
                <p className="mt-3 text-[clamp(0.85rem,1.05vw,1.05rem)] leading-relaxed text-[var(--muted)]" data-id="element-235" data-mp="1cvyjdgvrowe9">
                  {step.body}
                </p>
              </Card>
            </Fade>
            {index < steps.length - 1 ? <div className="flex items-center" data-id="element-236" data-mp="2p7sc7c17irlf">
                <ChevronRightIcon className="h-6 w-6 text-[var(--brand-green-lighter)]" aria-hidden="true" data-id="element-237" data-mp="2p8lm2lvgpx7s" />
              </div> : null}
          </React.Fragment>)}
      </div>

      <Fade delay={0.6} className="mt-[clamp(1rem,1.8vw,1.75rem)] flex-shrink-0" data-id="element-238" data-mp="2u6vj720qz7w1">
        <p className="border-l-2 border-[var(--brand-green)] pl-4 text-[clamp(1rem,1.5vw,1.5rem)] font-semibold text-[var(--fg)]" data-id="element-239" data-mp="38v9tfy0htymm">
          We feed your tech stack. We don&rsquo;t compete with it.
        </p>
      </Fade>
    </Slide>;
}